import { memo } from 'react'
import { PencilIcon, LockClosedIcon, TrashIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'
import GlassmorphButton from '../../ui/GlassmorphButton'
import { trackButtonClick } from '../../../utils/analytics'

/**
 * ProfileActionButtons - Profile management action buttons
 * Handles edit, password change, delete account, and logout
 */
const ProfileActionButtons = memo(function ProfileActionButtons({
  isEditingProfile,
  showPasswordSection,
  showDeleteSection,
  onEditToggle,
  onPasswordToggle,
  onDeleteToggle,
  onLogout,
  userId,
  hasGoogleId,
  t
}) {
  return (
    <div className="flex flex-col gap-2">
      {/* Primary actions row */}
      <div className="flex gap-2">
        <GlassmorphButton
          variant="secondary"
          icon={PencilIcon}
          onClick={() => {
            trackButtonClick('edit_profile_toggle', 'profile_tab', { is_editing: !isEditingProfile })
            onEditToggle()
          }}
          size="sm"
          className="flex-1 px-2 py-2 text-xs font-medium"
        >
          {t('profile.editInfo')}
        </GlassmorphButton>
        {!hasGoogleId && (
          <GlassmorphButton
            variant="secondary"
            icon={LockClosedIcon}
            onClick={() => {
              trackButtonClick('change_password_toggle', 'profile_tab', { is_showing: !showPasswordSection })
              onPasswordToggle()
            }}
            size="sm"
            className="flex-1 px-2 py-2 text-xs font-medium"
          >
            {t('profile.changePassword')}
          </GlassmorphButton>
        )}
      </div>

      {/* Logout + Delete Account row */}
      <div className="flex gap-2">
        <GlassmorphButton
          variant="secondary"
          icon={ArrowRightOnRectangleIcon}
          onClick={() => {
            trackButtonClick('logout', 'profile_tab', { user_id: userId })
            onLogout()
          }}
          size="sm"
          className="flex-1 px-2 py-2 text-xs font-medium"
        >
          {t('nav.logout')}
        </GlassmorphButton>
        <GlassmorphButton
          variant="danger"
          icon={TrashIcon}
          onClick={() => {
            trackButtonClick('delete_account_toggle', 'profile_tab', { is_showing: !showDeleteSection })
            onDeleteToggle()
          }}
          size="sm"
          className="flex-1 px-2 py-2 text-xs font-medium"
        >
          {t('profile.deleteAccount')}
        </GlassmorphButton>
      </div>
    </div>
  )
})

export default ProfileActionButtons
